import styled from 'styled-components';
import AddCircleIcon from '@material-ui/icons/AddCircle';

export const CircledXIcon = styled(AddCircleIcon)`
  transform: rotate(45deg);
`;
